import { InboxSortMode, isInboxSortMode } from '@bariendo/lib/inbox-sort';
import { useLocalStorage } from '@mantine/hooks';

function getStorageKey(profileId: string | undefined): string {
  return profileId ? `inbox-sort-mode-${profileId}` : 'inbox-sort-mode';
}

export function useInboxSort(profileId: string | undefined): [InboxSortMode, (mode: InboxSortMode) => void] {
  const [sortMode, setSortMode] = useLocalStorage<InboxSortMode>({
    key: getStorageKey(profileId),
    defaultValue: InboxSortMode.NEWEST_FIRST,
    getInitialValueInEffect: false,
  });

  const setValidatedSortMode = (mode: InboxSortMode) => {
    setSortMode(isInboxSortMode(mode) ? mode : InboxSortMode.NEWEST_FIRST);
  };

  const validatedSortMode = isInboxSortMode(sortMode) ? sortMode : InboxSortMode.NEWEST_FIRST;

  return [validatedSortMode, setValidatedSortMode];
}
